import { FormCategory } from "../../enums/common";
import { Locales } from "../enums/locales";
export const RaffleSquareDefaultBannerUrl = {
    [Locales.EN]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067062/default-banners/raffleSquareDefaultBannerV2-en.jpg",
    [Locales.FR]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067064/default-banners/raffleSquareDefaultBannerV2-fr.jpg",
    [Locales.ES]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067064/default-banners/raffleSquareDefaultBannerV2-fr.jpg",
    [Locales.DE]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067064/default-banners/raffleSquareDefaultBannerV2-fr.jpg",
};
export const MembershipSquareDefaultBannerUrl = {
    [Locales.EN]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067060/default-banners/membershipSquareDefaultBannerV2-en.jpg",
    [Locales.FR]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067061/default-banners/membershipSquareDefaultBannerV2-fr.jpg",
    [Locales.ES]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067061/default-banners/membershipSquareDefaultBannerV2-fr.jpg",
    [Locales.DE]: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067061/default-banners/membershipSquareDefaultBannerV2-fr.jpg",
};
const CLOUDINARY_BASE_DESKTOP = "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto:best/v1778067108/features/live-form-editor/desktop";
const CLOUDINARY_BASE_MOBILE = "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1778067088/features/live-form-editor/mobile";
const DESKTOP_FORM_PREVIEW_SLUGS = {
    [Locales.EN]: {
        [FormCategory.Event]: "event-form-desktop-preview-en.webp",
        [FormCategory.DonationForm]: "donation-form-desktop-preview-en.webp",
        [FormCategory.MembershipV2]: "membership-form-desktop-preview-en.webp",
        [FormCategory.PeerToPeerCampaign]: "p2p-form-desktop-preview-en.webp",
        [FormCategory.Custom]: "custom-form-desktop-preview-en.webp",
        [FormCategory.Lottery]: "raffle-form-desktop-preview-en.webp",
        [FormCategory.Sweepstakes]: "Sweepstakes-Desktop.webp",
        [FormCategory.Auction]: "auction-form-desktop-preview-en.webp",
        [FormCategory.Shop]: "shop-form-desktop-preview-en.webp",
    },
    [Locales.DE]: {
        [FormCategory.Event]: "event-form-desktop-preview-de.webp",
        [FormCategory.DonationForm]: "donation-form-desktop-preview-de.webp",
        [FormCategory.MembershipV2]: "membership-form-desktop-preview-de.webp",
        [FormCategory.PeerToPeerCampaign]: "p2p-form-desktop-preview-de.webp",
        [FormCategory.Custom]: "custom-form-desktop-preview-de.webp",
        [FormCategory.Lottery]: "raffle-form-desktop-preview-de.webp",
        [FormCategory.Sweepstakes]: "Sweepstakes-Desktop-DE.webp",
        [FormCategory.Auction]: "auction-form-desktop-preview-de.webp",
        [FormCategory.Shop]: "shop-form-desktop-preview-de.webp",
    },
    [Locales.ES]: {
        [FormCategory.Event]: "event-form-desktop-preview-en.webp",
        [FormCategory.DonationForm]: "donation-form-desktop-preview-en.webp",
        [FormCategory.MembershipV2]: "membership-form-desktop-preview-en.webp",
        [FormCategory.PeerToPeerCampaign]: "p2p-form-desktop-preview-en.webp",
        [FormCategory.Custom]: "custom-form-desktop-preview-en.webp",
        [FormCategory.Lottery]: "raffle-form-desktop-preview-en.webp",
        [FormCategory.Sweepstakes]: "Sweepstakes-Desktop-ES.webp",
        [FormCategory.Auction]: "auction-form-desktop-preview-en.webp",
        [FormCategory.Shop]: "shop-form-desktop-preview-en.webp",
    },
    [Locales.FR]: {
        [FormCategory.Event]: "event-form-desktop-preview-fr.webp",
        [FormCategory.DonationForm]: "donation-form-desktop-preview-fr.webp",
        [FormCategory.MembershipV2]: "membership-form-desktop-preview-fr.webp",
        [FormCategory.PeerToPeerCampaign]: "p2p-form-desktop-preview-fr.webp",
        [FormCategory.Custom]: "custom-form-desktop-preview-fr.webp",
        [FormCategory.Lottery]: "raffle-form-desktop-preview-fr.webp",
        [FormCategory.Sweepstakes]: "Sweepstakes-Desktop-FR.webp",
        [FormCategory.Auction]: "auction-form-desktop-preview-fr.webp",
        [FormCategory.Shop]: "shop-form-desktop-preview-fr.webp",
    },
};
const MOBILE_FORM_PREVIEW_SLUGS = {
    [Locales.EN]: {
        [FormCategory.Event]: "event-form-mobile-preview-en.webp",
        [FormCategory.DonationForm]: "donation-form-mobile-preview-en.webp",
        [FormCategory.MembershipV2]: "membership-form-mobile-preview-en.webp",
        [FormCategory.PeerToPeerCampaign]: "p2p-form-mobile-preview-en.webp",
        [FormCategory.Custom]: "custom-form-mobile-preview-en.webp",
        [FormCategory.Lottery]: "raffle-form-mobile-preview-en.webp",
        [FormCategory.Sweepstakes]: "Sweepstakes.webp",
        [FormCategory.Auction]: "auction-form-mobile-preview-en.webp",
        [FormCategory.Shop]: "shop-form-mobile-preview-en.webp",
    },
    [Locales.DE]: {
        [FormCategory.Event]: "event-form-mobile-preview-de.webp",
        [FormCategory.DonationForm]: "donation-form-mobile-preview-de.webp",
        [FormCategory.MembershipV2]: "membership-form-mobile-preview-de.webp",
        [FormCategory.PeerToPeerCampaign]: "p2p-form-mobile-preview-de.webp",
        [FormCategory.Custom]: "custom-form-mobile-preview-de.webp",
        [FormCategory.Lottery]: "raffle-form-mobile-preview-de.webp",
        [FormCategory.Sweepstakes]: "SweepstakesDE.webp",
        [FormCategory.Auction]: "auction-form-mobile-preview-de.webp",
        [FormCategory.Shop]: "shop-form-mobile-preview-de.webp",
    },
    [Locales.ES]: {
        [FormCategory.Event]: "event-form-mobile-preview-en.webp",
        [FormCategory.DonationForm]: "donation-form-mobile-preview-en.webp",
        [FormCategory.MembershipV2]: "membership-form-mobile-preview-en.webp",
        [FormCategory.PeerToPeerCampaign]: "p2p-form-mobile-preview-en.webp",
        [FormCategory.Custom]: "custom-form-mobile-preview-en.webp",
        [FormCategory.Lottery]: "raffle-form-mobile-preview-en.webp",
        [FormCategory.Sweepstakes]: "SweepstakesES.webp",
        [FormCategory.Auction]: "auction-form-mobile-preview-en.webp",
        [FormCategory.Shop]: "shop-form-mobile-preview-en.webp",
    },
    [Locales.FR]: {
        [FormCategory.Event]: "event-form-mobile-preview-fr.webp",
        [FormCategory.DonationForm]: "donation-form-mobile-preview-fr.webp",
        [FormCategory.MembershipV2]: "membership-form-mobile-preview-fr.webp",
        [FormCategory.PeerToPeerCampaign]: "p2p-form-mobile-preview-fr.webp",
        [FormCategory.Custom]: "custom-form-mobile-preview-fr.webp",
        [FormCategory.Lottery]: "raffle-form-mobile-preview-fr.webp",
        [FormCategory.Sweepstakes]: "SweepstakesFR.webp",
        [FormCategory.Auction]: "auction-form-mobile-preview-fr.webp",
        [FormCategory.Shop]: "shop-form-mobile-preview-fr.webp",
    },
};
export const getDesktopFormPreviewUrl = (locale, formCategory) => `${CLOUDINARY_BASE_DESKTOP}/${DESKTOP_FORM_PREVIEW_SLUGS[locale][formCategory]}`;
export const getMobileFormPreviewUrl = (locale, formCategory) => `${CLOUDINARY_BASE_MOBILE}/${MOBILE_FORM_PREVIEW_SLUGS[locale][formCategory]}`;
const REGISTER_V4_S3_BASE_URL = "https://simplyk-bucket-production.s3.ca-central-1.amazonaws.com/register-v4";
const registerBackgroundLocaleSuffix = (locale) => locale === Locales.ES ? "en" : locale.toLowerCase();
export const getRegisterCategoryBackgroundImageUrl = (category, breakpoint, locale) => `${REGISTER_V4_S3_BASE_URL}/${category}/${breakpoint}-registration-background-${registerBackgroundLocaleSuffix(locale)}.jpg`;
export const getRegisterDefaultBackgroundImageUrl = (breakpoint, locale) => `/images/internationalization/register/${breakpoint}-registration-background-${registerBackgroundLocaleSuffix(locale)}.jpg`;
export const FromScratchEmailTemplatePreviewSvgUrl = "/images/internationalization/email-templates/from_scratch_email_template.svg";
export const NewsletterCrossSellImageUrl = {
    [Locales.EN]: "/images/internationalization/cross-sell/cross_sell_newsletter_en.webp",
    [Locales.FR]: "/images/internationalization/cross-sell/cross_sell_newsletter_fr.webp",
    [Locales.ES]: "/images/internationalization/cross-sell/cross_sell_newsletter_en.webp",
    [Locales.DE]: "/images/internationalization/cross-sell/cross_sell_newsletter_de.webp",
};
export const TipRefundHero100FreeImageUrl = {
    [Locales.EN]: "/images/internationalization/tip-refund/refund-page-hero-100-free-EN.svg",
    [Locales.FR]: "/images/internationalization/tip-refund/refund-page-hero-100-free-FR.svg",
    [Locales.ES]: "/images/internationalization/tip-refund/refund-page-hero-100-free-FR.svg",
    [Locales.DE]: "/images/internationalization/tip-refund/refund-page-hero-100-free-DE.svg",
};
export const TipRefundTipModalImageUrl = {
    [Locales.EN]: "/images/internationalization/tip-refund/refund-page-tip-modal-EN.svg",
    [Locales.FR]: "/images/internationalization/tip-refund/refund-page-tip-modal-FR.svg",
    [Locales.ES]: "/images/internationalization/tip-refund/refund-page-tip-modal-FR.svg",
    [Locales.DE]: "/images/internationalization/tip-refund/refund-page-tip-modal-DE.svg",
};
export const TipRefundWithZeffyImageUrl = {
    [Locales.EN]: "/images/internationalization/tip-refund/refund-page-with-zeffy-EN.svg",
    [Locales.FR]: "/images/internationalization/tip-refund/refund-page-with-zeffy-FR.svg",
    [Locales.ES]: "/images/internationalization/tip-refund/refund-page-with-zeffy-FR.svg",
    [Locales.DE]: "/images/internationalization/tip-refund/refund-page-with-zeffy-DE.svg",
};
export const ShareFormLinkedButtonImageUrl = "/images/internationalization/share-form-modal/linked_button.svg";
export const ShareFormEmbedImageUrl = "/images/internationalization/share-form-modal/form_embed.svg";
export const ShareFormButtonPopupImageUrl = "/images/internationalization/share-form-modal/button_popup.svg";
